module.exports = __webpack_public_path__ + "components/app-store/static/s5-5bc70c9ca19087e42c873e955b78c6ab.jpg";